import useLanguages from './useLanguages';

export default useLanguages;
